import classnames from "classnames"

export const jumboClass = classnames(
    "mx-2 w-full",
    "sm:max-w-xl sm:mx-0"
)

